import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/members/:id(/:edit)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/MemberContainer',
      './modules/member'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Member = require('./containers/MemberContainer').default
      const actions = require('./modules/member')
      const reducer = require('./modules/member').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'member', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId, nextState.params.edit))

      /*  Return getComponent   */
      cb(null, Member)

    /* Webpack named bundle   */
    }, 'member')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Member/index.js